import { Breadcrumbs, Link, TablePagination, Typography } from "@mui/material";
import { useDiarioObraListaViewModel } from "../../viewModels/diario_obra_lista_view_model";
import RefreshButton from "../../../../../common/components/refresh_button";
import PrimaryButton from "../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import {
  PageTopBar,
  ThreeSlotLayout,
} from "../../../../../common/components/page_top_bar";
import { useMemo } from "react";
import { GenerateDiarioObraColumns } from "./columns";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { DiarioObrasLista } from "../../../domain/models/diario_obras_lista";
import { Header } from "./components/header";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import { useNavigate } from "react-router";
import { CopiaDiarioModal } from "./components/copia_diario_obras_modal";
import {
  GRID_CHECKBOX_SELECTION_FIELD,
  GridPinnedColumnFields,
} from "@mui/x-data-grid";
import { ReportViewerModal } from "../../../../../common/components/report_viewer_modal";

export const DiarioObra_lista = () => {
  const navigate = useNavigate();
  const viewModel = useDiarioObraListaViewModel();
  const DiarioObraListalColumns = useMemo(() => {
    return GenerateDiarioObraColumns({
      onActionEditar: viewModel.handleCadastroDiarioOpenState,
      onActionDeletar: viewModel.handleDeleteDiarioModalOpenState,
      onActionCopiar: viewModel.handleCopiaOpenState,
      onActionExportar: viewModel.handleReportDiarioObraIndividual,
    });
  }, [
    viewModel.handleCadastroDiarioOpenState,
    viewModel.handleCopiaOpenState,
    viewModel.handleDeleteDiarioModalOpenState,
    viewModel.handleReportDiarioObraIndividual,
  ]);

  const pinnedColumns = useMemo((): GridPinnedColumnFields => {
    return viewModel.diarioObrasLista.length > 0
      ? {
          left: [GRID_CHECKBOX_SELECTION_FIELD],
          right: ["IdDiarioObras"],
        }
      : {};
  }, [viewModel.diarioObrasLista.length]);

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <div className="w-[250px] ">
                <PrimaryButton
                  buttonColor="secondary"
                  onClick={() => viewModel.handleAprovaModal()}
                >
                  Aprovar Selecionados
                </PrimaryButton>
              </div>
              <div className="flex flex-row gap-2">
                <div className="w-[140px] ">
                  <PrimaryButton
                    startIcon={
                      <DynamicIcon
                        nameIcon="AddRounded"
                        size={25}
                        className="text-white"
                      />
                    }
                    onClick={() => navigate("/DiarioObra_cadastro/")}
                  >
                    Novo
                  </PrimaryButton>
                </div>
              </div>
            </div>
          }
        />
      </PageTopBar>
      <form>
        <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit">
              Diário de Obras
            </Link>
            <Typography className="text-primary-green">
              Diário de Obras Lista
            </Typography>
          </Breadcrumbs>
          <div className="div flex justify-between items-center flex-col gap-6">
            <div className="flex gap-2 items-center w-full">
              <h1 className="text-3xl font-medium text-black dark:text-white">
                Diário de Obras Lista
              </h1>
              <RefreshButton onClick={viewModel.handleReload} />
            </div>

            <Header
              onClearFilters={viewModel.handleClearFilters}
              handleResponsavelChange={viewModel.handleResponsavelChange}
              handleClienteChange={viewModel.handleClienteChange}
              handleFornecedorChange={viewModel.handleFornecedorChange}
              handleTipoDiaPraticavel={viewModel.handleTipoDiaPraticavelChange}
              handleCentroDeCusto={viewModel.handleCentroDeCustoChange}
              handleTipoTempo={viewModel.handleTipoTempoChange}
              handleTipoStatus={viewModel.handleTipoStatusChange}
              ResponsavelPesquisa={viewModel.filters.ResponsavelPesquisa}
              FornecedorPesquisa={viewModel.filters.FornecedorPesquisa}
              ClientePesquisa={viewModel.filters.ClientePesquisa}
              centroDeCusto={viewModel.filters.centroDeCusto}
              centroDeCustoLista={viewModel.filters.centroDeCustoLista ?? []}
              tipoTempo={viewModel.filters.TipoTempo}
              tipoStatus={viewModel.filters.TipoStatus}
              tipoDiaPraticavel={viewModel.filters.TipoDiaPraticavel}
              dataReceberAte={viewModel.filters.dataReceberAte}
              dataReceberDe={viewModel.filters.dataReceberDe}
              handleDataReceberRangeChange={
                viewModel.handleDataReceberRangeChange
              }
            />
            <StyledDataGrid
              tableName="Diario_Obras_lista"
              disableColumnMenu={false}
              disableRowSelectionOnClick={true}
              checkboxSelection={true}
              isRowSelectable={(params) => params.row.Status !==1}
              getRowId={(row: DiarioObrasLista) => row.IdDiarioObras}
              onRowSelectionModelChange={
                viewModel.handleRowSelectionModelChange
              }
              columns={DiarioObraListalColumns}
              loading={viewModel.loading}
              rows={viewModel.diarioObrasLista}
              rowCount={viewModel.pagination.totalItems}
              sx={{
                "& .status-header": {
                  backgroundColor: "#AFDFD5",
                  color: "#000",
                },
              }}
              autoHeight={true}
              textSize="pequeno"
              getRowHeight={() => "auto"}
              pinnedColumns={pinnedColumns}
              pageSizeOptions={[10, 25, 50, 100]}
              paginationMode="server"
              paginationModel={{
                page: viewModel.pagination.page,
                pageSize: viewModel.pagination.rowsPerPage,
              }}
            />

            <TablePagination
              component="div"
              count={viewModel.pagination.totalItems}
              page={viewModel.pagination.page - 1}
              onPageChange={(_, p) => viewModel.handlePageChange(p)}
              rowsPerPageOptions={[10, 25, 50, 100]}
              rowsPerPage={viewModel.pagination.rowsPerPage}
              onRowsPerPageChange={(e) =>
                viewModel.handleRowsPerPageChange(parseInt(e.target.value))
              }
            />
          </div>
        </div>
      </form>
      <DeleteDialog
        open={viewModel.diarioObraDeleteModal}
        saving={viewModel.saving}
        onClose={() => viewModel.handleDeleteDiarioModalOpenState(null, false)}
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.handleDeleteConfirmaDiario}
      />

      {/* ModalCopia */}
      <CopiaDiarioModal
        open={viewModel.openCopiaModal}
        saving={viewModel.saving}
        onSubmit={viewModel.handleSubmitCopia}
        onClose={() => viewModel.handleCopiaOpenState(null, false)}
      />

      {/* Relatorio */}
      <ReportViewerModal reportViewerState={viewModel.reportViewerState} />
    </>
  );
};
